import React, { useState, useEffect, useContext } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useNavigate } from "react-router-dom";
import * as Yup from 'yup';
import { signup } from '../../Services/Authentication.Serivice';
import { login } from '../../Services/Authentication.Serivice';
import Logo from '../../Assets/images/logo.png';
import Banner from '../../Assets/images/banner.jpg';
import Toaster from '../../Components/Toaster';
import TokenService from "../../Services/Token.service";
import { GlobalInfo } from '../../Contexts/GlobalContext';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Loader from '../../Components/Loader';

function Signup({ setIsLoggedIn }){
    const { updateUserDetails } = useContext(GlobalInfo); 

    const navigate = useNavigate();
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState(''); // 'success' or 'error'
    const dirPath = process.env.REACT_APP_SUB_DIR;
    
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const togglePassword = () => setShowPassword(prev => !prev);
    const toggleConfirmPassword = () => setShowConfirmPassword(prev => !prev);

    const handleLogin = () => {
        navigate("/login");
    };
    const [loading, setLoading] = useState(false);
    const initialValues = {
        first_name: '',
        middle_name: '',
        last_name: '',
        email: '',
        password: '',
        confirm_password: '',
        //phone_number: '',
        // gender: 'XY',
    };

    const validationSchema = Yup.object({
        first_name: Yup.string()
            //.matches(/^\S*$/, 'No spaces are allowed')
            .min(2, 'First Name must at least 2 characters')
            .max(30, 'First Name must not be more than 30 characters')
            .matches(/^[A-Za-z0-9\s]+$/, 'Only letters and numbers are allowed')
            .required('Please enter first name'),
        middle_name: Yup.string()
            .min(2, 'Middle Name must at least 2 characters')
            .max(30, 'Middle Name must not be more than 30 characters')
            .matches(/^[A-Za-z0-9\s]+$/, 'Only letters and numbers are allowed')
            .required('Please enter middle name'),
        last_name: Yup.string()
            .min(2, 'Last Name must at least 2 characters')
            .max(30, 'Last Name must not be more than 30 characters')
            .matches(/^[A-Za-z0-9\s]+$/, 'Only letters and numbers are allowed')
            .required('Please enter last name'),
        email: Yup.string()
            .email('Invalid email format')
            //.min(2, 'Last Name must at least 2 characters')
            .max(50, 'Email must not be more than 50 characters')
            .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email format')
            .required('Please enter email address'),
        password: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters long')
            .max(20, 'Password must not be greater than 20 characters')
            .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
            .matches(/[a-z]/, 'Must contain at least one lowercase letter')
            .matches(/[0-9]/, 'Must contain at least one digit')
            .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Must contain at least one special character'),
        confirm_password: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required('Confirm Password is required'),
    });

    function getNavigationPath(slug) {
        const routes = {
            "admin-controls": "sample-requests",
            "donor-controls": "job-board",
            "requestor-controls": "requestor-sample-requests",
            "profile-management": "profile-management",
        }; 
        // Return the mapped route or the original slug if no match is found
        return routes[slug] || slug;
    }

    // async function initiatePlaidVerification(userId) {
    //     const res = await fetch(`/api/plaid/create-link-token?user_id=${userId}`);
    //     const { link_token } = await res.json();

    //     const handler = window.Plaid.create({
    //         token: link_token,
    //         onSuccess: async (public_token, metadata) => {
    //         // Exchange token on backend
    //         await fetch("/api/plaid/exchange-token", {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({ public_token, user_id: userId })
    //         });
    //         },
    //         onExit: (err, metadata) => {
    //         console.error("Plaid exited", err, metadata);
    //         }
    //     });

    //     handler.open();
    // }


    const handleSubmit = (values, { setSubmitting }) => {
        //console.log("Form submitted with values:", values);
        // Add additional fields before sending
        const payload = {
            ...values,
            username: values.email, // username = email
            user_type: [3],            // fixed user type value
            sequence: 1
        };
        console.log("Form submitted with values:", payload);
        //setSubmitting(false);
        //return;
        signup(payload)
            .then(response => {
                console.log("response", response);
                // Step 3: Trigger Plaid verification
                //await initiatePlaidVerification(response.user_id);
                if (response.status && response.link_token) {
                    //  Initialize Plaid popup
                    const handler = window.Plaid.create({
                        token: response.link_token,
                        onSuccess: async (public_token, metadata) => {
                            console.log(" Plaid success:", public_token, metadata);
                            
                            // Extract link_session_id
                            const linkSessionId = metadata?.link_session_id;
                            
                            // If Plaid succeeded and we have a session ID, call signup again
                            if (linkSessionId) {
                                const secondPayload = {
                                ...payload,
                                link_session_id: linkSessionId,
                                };

                                console.log("Sending signup again with link_session_id:", secondPayload);

                                try {
                                    setLoading(true);
                                    const secondResponse = await signup(secondPayload);
                                    console.log(" Second signup response:", secondResponse);
                                    //  Auto-login after successful second signup
                                    if (secondResponse.status === true) {
                                        const loginPayload = {
                                            username: secondPayload.username,
                                            password: secondPayload.password,
                                        };

                                        try {

                                            const loginResponse = await login(loginPayload);
                                            console.log(" Auto-login response:", loginResponse);

                                            if (loginResponse.status === false) {
                                                setToastMessage(loginResponse.error || "Auto-login failed.");
                                                setToastVariant("error");
                                                setShowToast(true);
                                                setLoading(false);
                                                return;
                                            }
                                            handler.destroy();
                                            setLoading(false);
                                            updateUserDetails(loginResponse); 
                                            //  Save token, set user, navigate based on role
                                            TokenService.setUser(loginResponse);
                                            setIsLoggedIn(true);

                                            const role = loginResponse.roles.find((r) => r.toLowerCase() === "superadmin");
                                            if (role) {
                                                navigate(`/admin/sample-requests`);
                                                TokenService.updatePrevLink('/admin/sample-requests');
                                            } else {
                                                const currentRole = loginResponse.roles[0]?.toLowerCase();
                                                const slug = loginResponse.menus[0].slug;
                                                const navigationPath = getNavigationPath(slug);

                                                if (navigationPath === "profile-management") {
                                                    navigate(`/profile-management/profile-settings`);
                                                } else {
                                                    navigate(`/${currentRole}/${loginResponse.menus[0].children[0].slug}`);
                                                    TokenService.updatePrevLink(`/${currentRole}/${loginResponse.menus[0].children[0].slug}`);
                                                }
                                            }

                                            setToastMessage("Registration successful! You are now logged in.");
                                            setToastVariant("success");
                                            setShowToast(true);

                                        } catch (loginError) {
                                            setLoading(false);
                                            console.error(" Auto-login error:", loginError);
                                            setToastMessage("Automatic login failed. Please log in manually.");
                                            setToastVariant("error");
                                            setShowToast(true);
                                            navigate("/login");
                                        }
                                    } else {
                                        setToastMessage(secondResponse.message || "Registration failed after verification.");
                                        setLoading(false);
                                        setToastVariant("error");
                                        setShowToast(true);

                                        setTimeout(() => {
                                            navigate("/login");
                                        }, 3000);
                                    }
                                    /*setToastMessage("Registration successful! Check your email for next steps.");
                                    setToastVariant("success");
                                    setShowToast(true);
                                    navigate("/login");*/
                                } catch (err) {
                                    setLoading(false);
                                    console.error("Error during second signup:", err);
                                    setToastMessage("Error sending verification data to server.");
                                    setToastVariant("error");
                                    setShowToast(true);
                                }
                            } else {
                                setToastMessage("Plaid verification did not return a session ID.");
                                setToastVariant("error");
                                setShowToast(true);
                            }
                        },
                        onExit: (err, metadata) => {
                        console.warn("Plaid popup closed or exited", err, metadata);
                        if (err) {
                            setToastMessage("Plaid verification was not completed.");
                            setToastVariant("error");
                            setShowToast(true);
                        }
                        },
                    });
                handler.open(); // 🚀 Launch Plaid Link popup
                } else {
                    setToastMessage(response.error || "Unable to start Plaid verification.");
                    setToastVariant("error");
                    setShowToast(true);
                }
                return;
                if (response.status === false) {
                    setToastMessage(response.error || "Something went wrong");
                    setShowToast(true);
                    setToastVariant('error');
                    return;
                }
                //updateUserDetails(response); 
                TokenService.setUser(response); 
                setIsLoggedIn(true);
                //const navigationPath = getNavigationPath(slug);
                navigate("/login");
                /*
                const role = response.roles.find((r) => r.toLowerCase() === "superadmin");
                if (role) {                    
                    navigate(`/admin/sample-requests`);
                    TokenService.updatePrevLink('/admin/sample-requests');
                } else { 
                    
                    // Navigate to the respective role's page
                    const currentRole = response.roles[0]?.toLowerCase(); // Default to the first role if no "Superadmin" is found
                    const slug = response.menus[0].slug;
                    const navigationPath = getNavigationPath(slug);

                    if (navigationPath === "profile-management") {
                        navigate(`/profile-management/profile-settings`);
                        
                    } else {
                        navigate(`/${currentRole}/${response.menus[0].children[0].slug}`);
                        TokenService.updatePrevLink(`/${currentRole}/${response.menus[0].children[0].slug}`);

                    }
                }
                */

            })
            .catch(error => {
                setToastMessage(error.response?.data?.error || "Something went wrong");
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
                setSubmitting(false);
            });
    };  

    return (
    
        <>
        
        <main className="d-flex align-items-center bg-white"  style={{background:` url(${Banner}) left center no-repeat` , backgroundSize: 'cover'}}>
            <section className="el-login-sec d-flex justify-content-center el-register-sec  w-100">
                <div className=" ml-auto d-block   ">
                    <div className="el-login-background el-register-background  d-block box-shadow-none  ">
                        <div className="el-login-card  ml-lg-auto d-block  ">
                            <div className="el-login-logo">
                                <img src={Logo} className="img-fluid logindonar-x-logo" alt="Donor X logo" />
                            </div>
                        
                            <h3 className="mb-1">Register your account</h3>
                            <p>Welcome to Donor x, please put your personal details below to start using the app </p>
                            <div className="el-login-form">
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={validationSchema}
                                        validateOnBlur={false} 
                                        validateOnChange={true} 
                                        onSubmit={handleSubmit}
                                    >
                                        {({ isSubmitting }) => (
                                            <Form>
                                                <div class="row">

                                                <div className="el-form-group mb-1 col-md-4">
                                                    <label htmlFor="first_name" className="form-label">First Name<span className="text-red">*</span></label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter First Name"
                                                        id="first_name"
                                                        name="first_name"
                                                    />
                                                    <ErrorMessage name="first_name" component="div" className="text-danger" />
                                                </div>
                                                <div className="el-form-group mb-1 col-md-4">
                                                    <label htmlFor="middle_name" className="form-label">Middle Name<span className="text-red">*</span></label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Middle Name"
                                                        id="middle_name"
                                                        name="middle_name"
                                                    />
                                                    <ErrorMessage name="middle_name" component="div" className="text-danger" />
                                                </div>
                                                <div className="el-form-group mb-1 col-md-4">
                                                    <label htmlFor="last_name" className="form-label">Last Name<span className="text-red">*</span></label>
                                                    <Field
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Last Name"
                                                        id="last_name"
                                                        name="last_name"
                                                    />
                                                    <ErrorMessage name="last_name" component="div" className="text-danger" />
                                                </div>
                                                <div className="el-form-group mb-1 col-md-12">
                                                    <label htmlFor="email" className="form-label">Email<span className="text-red">*</span></label>
                                                    <Field
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="Enter Email"
                                                        id="email"
                                                        name="email"
                                                    />
                                                    <ErrorMessage name="email" component="div" className="text-danger" />
                                                </div>
                                                <div className="el-form-group mb-1 col-md-6">
                                                    <label htmlFor="password" className="form-label">Password<span className="text-red">*</span></label>
                                                    <div className="position-relative">
                                                        <Field
                                                            type={showPassword ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Enter Password"
                                                            id="password"
                                                            name="password"
                                                            maxLength = {20}
                                                        />
                                                        <span 
                                                            className="position-absolute" 
                                                            style={{ right: "10px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                                                            onClick={togglePassword}
                                                        >
                                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                        </span>
                                                    </div>
                                                    <ErrorMessage name="password" component="div" className="text-danger" />
                                                </div>
                                                <div className="el-form-group mb-1 col-md-6">
                                                    <label htmlFor="confirm_password" className="form-label">Confirm Password<span className="text-red">*</span></label>
                                                    <div className="position-relative">
                                                    <Field
                                                        type={showConfirmPassword ? "text" : "password"}
                                                        className="form-control"
                                                        placeholder="Enter Confirm Password"
                                                        id="confirm_password"
                                                        name="confirm_password"
                                                        maxLength = {20}
                                                    />
                                                    <span 
                                                        className="position-absolute" 
                                                        style={{ right: "10px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                                                        onClick={toggleConfirmPassword}
                                                    >
                                                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                                    </span>
                                                    
                                                    </div>
                                                    <ErrorMessage name="confirm_password" component="div" className="text-danger" />
                                                </div>
                                                <div className="el-form-btn-submit">
                                                    <button type="submit" className="el-btn-primary" disabled={isSubmitting}>
                                                        {isSubmitting ? 'Registering...' : 'Register Now'}
                                                    </button>
                                                </div>
                                                <div className="el-form-link text-center">                                                    
                                                    Already have an account? <b><a onClick={() => { navigate('/login') }} className="elfotget-password el-text-dark">Login here</a></b>
                                                </div>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <Loader loading={loading} />
        {/* Reusable Toaster */}
        <Toaster
            show={showToast}
            message={toastMessage}
            variant={toastVariant}
            onClose={() => setShowToast(false)}
        />

        </>
    );
}

export default Signup;